import { Command, CommandGroup, CommandItem, CommandList } from "@/components/shadcn/command";
import { Address } from "@/lib/address";
import FilledCheck from "@/components/Icons/FilledCheck";
import { AddressGroup, AddressItem } from ".";
import { Network } from "@/Models/Network";
import { FC } from "react";
import AddressWithIcon from "./AddressWithIcon";
import { Partner } from "@/Models/Partner";
import { Wallet } from "@/Models/WalletProvider";
import { BookOpen } from "lucide-react";

type AddressBookProps = {
    addressBook: AddressItem[];
    onSelectAddress: (address: string, wallet: Wallet | undefined) => void;
    destination: Network;
    destination_address: string | undefined;
    partner?: Partner;
}

const AddressBook: FC<AddressBookProps> = ({ addressBook, onSelectAddress, destination, destination_address, partner }) => {

    return (
        <div className="text-left mt-1!">
            <Command>
                <CommandList>
                    <CommandGroup
                        heading={
                            <div className="flex items-center space-x-1">
                                <BookOpen className="h-4 w-4 stroke-2" aria-hidden="true" />
                                <p className="text-sm text-secondary-text">Address Book</p>
                            </div>
                        }
                        className="[&_[cmdk-group-heading]]:pb-1! [&_[cmdk-group-heading]]:px-0! py-0! px-0!"
                    >
                        <div className="w-full flex flex-col items-stretch max-h-[200px] overflow-y-auto styled-scroll gap-2">
                            {addressBook.sort(sortingByDate).map(item => {
                                const isSelected = Address.equals(item.address, destination_address!, destination!)
                                return (
                                    <CommandItem key={item.address} onSelect={() => onSelectAddress(item.address, item.wallet)} className={`group/addressItem px-3 py-3 hover:bg-secondary-400 w-full transition duration-200 bg-secondary-500 ${isSelected && 'bg-secondary-400'}`}>
                                        <div className={`flex items-center justify-between w-full`}>
                                            <AddressWithIcon addressItem={item} partner={partner} network={destination} />
                                            <div className="flex h-6 items-center px-1">
                                                {
                                                    isSelected &&
                                                    <FilledCheck />
                                                }
                                            </div>
                                        </div>
                                    </CommandItem>
                                )
                            })}
                        </div>
                    </CommandGroup>
                </CommandList>
            </Command>
        </div>
    )
}

const sortingByDate = (a: AddressItem, b: AddressItem) => {
    return (a.group === AddressGroup.RecentlyUsed && b.group === AddressGroup.ManualAdded) ? 0 : -1 +
        (a.date ? Math.abs(((new Date()).getTime() - new Date(a.date).getTime())) : 0)
        - (b.date ? Math.abs(((new Date()).getTime() - new Date(b.date).getTime())) : 0)
}

export default AddressBook;